import * as Sentry from '@sentry/browser';

const DEFAULT_ENVIRONMENT = PRODUCTION ? 'production' : 'development';

let initialized = false;

export function initializeSentry() {
    if (initialized) {
        return;
    }

    const dsn = CONFIGURATION && CONFIGURATION.sentryDsn;

    if (!dsn) {
        return;
    }

    const options = {
        dsn,
        environment: CONFIGURATION.sentryEnvironment || DEFAULT_ENVIRONMENT,
        sendDefaultPii: false
    };

    if (CONFIGURATION.sentryRelease) {
        options.release = CONFIGURATION.sentryRelease;
    }

    Sentry.init(options);

    initialized = true;
}

export function captureApiError(result = {}) {
    if (!initialized) {
        return;
    }

    const { status, data, config } = result;

    // Keep signal quality high for the first rollout.
    if (!(status === 0 || status >= 500)) {
        return;
    }

    const method = config && config.method ? config.method.toUpperCase() : 'UNKNOWN_METHOD';
    const endpoint = config && config.url ? config.url : 'UNKNOWN_URL';
    const backendErrorCode = data && data.error ? data.error : 'UNKNOWN_ERROR';
    const statusLabel = typeof status === 'number' ? status : 'UNKNOWN_STATUS';

    const exception = new Error(`API ${statusLabel} ${method} ${endpoint}`);

    Sentry.withScope((scope) => {
        scope.setLevel('error');
        scope.setTag('error.source', 'api');
        scope.setTag('http.method', method);
        scope.setTag('http.status_code', String(statusLabel));
        scope.setTag('api.error_code', backendErrorCode);
        scope.setTag('api.endpoint', endpoint);

        scope.setContext('api', {
            endpoint,
            method,
            status: statusLabel,
            errorCode: backendErrorCode
        });

        scope.setFingerprint(['api-error', String(statusLabel), backendErrorCode, method, endpoint]);

        Sentry.captureException(exception);
    });
}



// WEBPACK FOOTER //
// ./src/common/monitoring/sentry.js